import { render, staticRenderFns } from "./spinnerComponent.vue?vue&type=template&id=587a3709&scoped=true&"
import script from "./spinnerComponent.vue?vue&type=script&lang=js&"
export * from "./spinnerComponent.vue?vue&type=script&lang=js&"
import style0 from "./spinnerComponent.vue?vue&type=style&index=0&id=587a3709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a3709",
  null
  
)

export default component.exports